import styled from '@emotion/styled'

import type { FC } from 'react'

import {
  BoxLogo,
  RitualLogo,
  IntuitLogo,
  DominosLogo,
  AllerganLogo,
  VmwareLogo,
  LevisLogo,
  InstacartLogo,
  IbmLogo,
} from '@segment/matcha/components/CompanyLogos/Company'
import Divider from '@segment/matcha/components/Divider'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

const logosCopy = {
  heading: `You're in great company`,
  description: `Join 25,000+ companies who are using Segment to power world-class customer experiences.`,
}
const LogoSection: FC = () => {
  return (
    <>
      <CopyTextBase>
        <CopyText.Heading variant="h3">{logosCopy.heading}</CopyText.Heading>
        <CopyText.Description>{logosCopy.description}</CopyText.Description>
      </CopyTextBase>

      <Divider />
      <LogoGrid>
        <BoxLogo />
        <RitualLogo />
        <IntuitLogo />
        <DominosLogo />
        <AllerganLogo />
        <VmwareLogo />
        <LevisLogo />
        <InstacartLogo />
        <IbmLogo />
      </LogoGrid>
    </>
  )
}

const LogoGrid = styled.div`
  align-items: center;
  display: grid;
  gap: 32px;
  grid-template-columns: 1fr 1fr 1fr;
  justify-items: center;
  padding: 48px 0;

  svg {
    height: 32px;
  }
`

export default LogoSection
